<template>
    <div class="footer-component">
        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-7">
                        <h3>Wholesale Inquiries</h3>

                        <p class="text-white">
                            If you own a restaurant, bakery, chocolate shop, any kind of food business, or if you are interested in becoming a Dutché Reseller, simply send us a text through:
                        </p>

                        <p class="text-white">
                            <span class="contact-number">+63 922 863 6675</span>
                        </p>

                        <p class="text-white">
                            Or, you may go directly to our contact page:
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 offset-lg-1 d-none d-md-block browse-lg">
                        <div class="row mt-3 extra-space">
                            <div class="col-12">
                                <span class="footer-right-titles">
                                    Browse our pages
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <ul class="list-unstyled browse-list">
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('store') ? 'active' : ''" href="/store">Store</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('about') ? 'active' : ''" href="/about">About Us</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('find-us') ? 'active' : ''" href="/find-us#contact-form">Contact</a></li>
                                </ul>
                            </div>
                            <div class="col-6">
                                <ul class="list-unstyled browse-list">
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('find-us') ? 'active' : ''" href="/find-us">Locations</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('seasonal') ? 'active' : ''" href="/products/seasonal">Seasonal</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('journals') ? 'active' : ''" href="/journals">Blog</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="d-block d-lg-none">
                            <b-button class="block-button text-uppercase" href="/find-us#contact-form">Drop By Our Inbox</b-button>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 offset-lg-1 d-block d-md-none">
                        <div class="row mt-3 extra-space">
                            <div class="col-12">
                                <span class="footer-right-titles">
                                    Browse our pages
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <ul class="list-unstyled browse-list">
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('store') ? 'active' : ''" href="/store">Store</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('about') ? 'active' : ''" href="/about">About Us</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('find-us') ? 'active' : ''" href="/find-us#contact-form">Contact</a></li>
                                </ul>
                            </div>
                            <div class="col-6">
                                <ul class="list-unstyled browse-list">
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('find-us') ? 'active' : ''" href="/find-us">Locations</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('seasonal') ? 'active' : ''" href="/products/seasonal">Seasonal</a></li>
                                    <li class="pt-2"><a class="text-decoration-none text-white" :class="isActivePage('journals') ? 'active' : ''" href="/journals">Blog</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row d-block d-lg-none">
                    <div class="col-8">
                        <div class="social-media-icons">
                            <span class="footer-right-titles">
                                Follow us
                            </span>
                            <p class="text-white">
                                <SocialMediaShare
                                    twitterUrl="https://twitter.com/dutche_choco"
                                    facebookUrl="https://facebook.com/dutchechocolatesph"
                                    instagramUrl="https://www.instagram.com/dutchechocolatesph"
                                ></SocialMediaShare>
                            </p>
                        </div>
                    </div>
                    <div class="col-4">
                        <GotoTop></GotoTop>
                    </div>
                </div>
                <div class="row d-none d-lg-flex">
                    <div class="col-lg-7">
                        <div style="margin-top: 2.2rem">
                            <b-button class="block-button text-uppercase" href="/find-us#contact-form">Drop By Our Inbox</b-button>
                        </div>
                    </div>
                    <div class="col-lg-4 offset-lg-1">
                        <div class="social-media-icons">
                            <span class="footer-right-titles">
                                Follow us
                            </span>
                            <p class="text-white">
                                <SocialMediaShare
                                    twitterUrl="https://twitter.com/dutche_choco"
                                    facebookUrl="https://facebook.com/dutchechocolatesph"
                                    instagramUrl="https://www.instagram.com/dutchechocolatesph"
                                ></SocialMediaShare>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row copyright">
                    <div class="col-6 text-left">
                        <p>&copy; 2019 Dutche Chocolates</p>
                    </div>
                    <div class="col-6 text-right">
                        <p><a href="#">Terms of Use</a> <span class="dot"></span> <a href="/privacy-policy">Privacy</a></p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import GotoTop from "@/components/GotoTop.vue";
import SocialMediaShare from "@/components/SocialMediaShare";

export default {
    name: 'Footer',
    components: {
        GotoTop,
        SocialMediaShare
    },
    data() {
        return {
            slug: undefined
        }
    },
    mounted() {
        this.slug = window.location.pathname.split('/').pop();
    },
    methods: {
        isActivePage(page) {
            return page === this.slug;
        }
    }
}
</script>

<style lang="sass" scoped>
footer
    padding: 6rem 2rem 3rem
    min-height: 200px
    height: auto
    background-color: $dutche-primary-violet
    font-family: "Gotham"
    font-size: 16px

    h3
        color: $dutche-primary-yellow
        font-family: "Might Could"
        font-size: 1.75em

    .block-button
        border-radius: 0.25em
        background-color: $dutche-primary-yellow
        color: $dutche-primary-violet
        font-size: 1.8em
        font-weight: bold
        padding: 0.75rem
        width: 100%

    .block-button:hover
        background-color: $dutche-primary-yellow
        color: $dutche-primary-orange

    .contact-number
        color: $dutche-primary-yellow
        font-size: 1.5em
        font-weight: bold

    .footer-right-titles
        color: $dutche-primary-yellow
        font-size: 1.2em
        text-transform: uppercase
        font-weight: bold

    .browse-list a:focus,
    .browse-list a:hover,
    .active
        color: $dutche-primary-yellow !important

    .browse-lg
        padding-top: 2rem

    .copyright
        margin-top: 5.5rem

    .copyright p,
    .copyright a
        color: $white
        font-weight: bold

    .dot
        height: 5px
        width: 5px
        background-color: #fff
        border-radius: 50%
        display: inline-block
        margin: 0 0.2rem 0.1rem

@media (max-width: 992px)
    .extra-space
      margin-top: 3rem !important

@media (min-width: 576px)
    h3
        font-size: 3.5em !important

@media (min-width: 992px)
    h3
        font-size: 4em !important

    .block-button
        font-size: 1.5em

    .contact-number
        font-size: 3em !important

@media (max-width: 768px)
    h3
        font-size: 2.25em !important
    p
        font-size: 0.8em
    .block-button
        border-radius: 0.5rem !important
        background-color: $dutche-primary-yellow
        color: $dutche-primary-violet
        font-size: 1em !important
        font-weight: bold
        padding: 0.75rem
        width: 100%

    .footer-right-titles
        font-size: 0.9em !important

    .browse-list
        font-size: 0.8em !important
    
    .social-media-links .fa-2x
        font-size: 1.5em !important
@media (max-width: 575px)
    footer
        padding: 4rem 2rem 2rem

    .copyright
        margin-top: 3rem!important

@media (min-width: 400px) and (max-width: 576px)
    h3
        font-size: 2.5em !important

    p
        font-size: 0.7em

    .contact-number
        font-size: 1.8em !important

    .extra-space
      margin-top: 2.5rem !important
</style>
